import { useEffect, useState } from "react";

const isFull = () => typeof document !== "undefined" && !!document.fullscreenElement;

/**
 * Whether the page is fullscreen, following the browser (Esc, a phone's back
 * gesture), with `enter` and `toggle` (#223). Some embeds and phones refuse
 * fullscreen; the game still plays in the page, so a refusal is ignored.
 */
export function useFullscreen(): { full: boolean; enter: () => void; toggle: () => void } {
  const [full, setFull] = useState(isFull);
  useEffect(() => {
    const follow = () => setFull(isFull());
    follow();
    document.addEventListener("fullscreenchange", follow);
    return () => document.removeEventListener("fullscreenchange", follow);
  }, []);
  const enter = () => {
    if (isFull()) return;
    document.documentElement.requestFullscreen?.().catch(() => {});
  };
  const toggle = () => {
    if (isFull()) document.exitFullscreen?.().catch(() => {});
    else enter();
  };
  return { full, enter, toggle };
}
